import { Box } from '@mui/material';

export function FeatureIcon({
  icon,
  color = 'primary',
  size = 'large',
  disabled = false,
}: {
  icon: any;
  color:
    | 'primary'
    | 'secondary'
    | 'monochrome'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'disabled';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        placeItems: 'center',
        // A circle on a fully rounded theme, square on a theme with none.
        borderRadius: `${theme.buttonRadius.main}px`,
        [theme.breakpoints.down('sm')]: {
          borderRadius: `${theme.buttonRadius.mobile}px`,
        },
        width: size === 'small' ? 48 : size === 'large' ? 80 : 64,
        aspectRatio: '1 / 1',
        bgcolor: disabled ? 'monochrome.main' : `${color}.main`,
        color: disabled ? 'text.disabled' : `${color}.contrastText`,
        '&>svg': {
          fontSize: size === 'small' ? 24 : size === 'large' ? 40 : 32,
        },
      })}
    >
      {icon}
    </Box>
  );
}
